import { useState, useCallback, useEffect } from 'react';

import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';
import { toast } from 'react-toastify';

import { ButtonYellow, Layout } from '~/components';
import { PowerCreator } from '~/models/PowerCreator';
import api from '~/services/api';

import { Card } from './Card';

import { HeaderButtonsContainer } from './Card/styles';
import {
  Header,
  Container,
  HeaderWrapper,
  HeaderLabel,
  CardContainer,
  AlertContainer,
} from './styles';

const orderByName = (a: PowerCreator, b: PowerCreator): number => {
  if (a.tranning_method < b.tranning_method) {
    return -1;
  }
  return 1;
};

function MetLibraryImportMethods() {
  const { goBack } = useHistory();

  const [loading, setLoading] = useState(false);
  const [adminMethods, setAdminMethods] = useState<PowerCreator[]>([]);
  const [selectedMethodsIds, setSelectedMethodsIds] = useState<number[]>([]);

  const loadAdminMethods = useCallback(async () => {
    const { data } = await api.get<PowerCreator[]>(
      '/power-creators/all/admins',
    );

    setAdminMethods(data.sort(orderByName));

    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    loadAdminMethods();
  }, [loadAdminMethods]);

  const handleResetSelectedMethods = () => setSelectedMethodsIds([]);

  const handleSelectMethod = (methodId: string) => {
    const methodsIds = [...selectedMethodsIds, parseInt(methodId, 10)];

    setSelectedMethodsIds(methodsIds);
  };

  const handleRemoveMethod = (methodId: string) => {
    const methodsIds = selectedMethodsIds.filter(
      (method) => method !== parseInt(methodId, 10),
    );

    setSelectedMethodsIds(methodsIds);
  };

  const handleCopyMethods = async () => {
    try {
      setLoading(true);

      await api.post(`/power-creators/all/admins`, {
        exercicies: selectedMethodsIds,
      });

      setLoading(false);

      toast.success('Exercícios copiados com sucesso!');

      goBack();
    } catch (error) {
      setLoading(false);
      console.log('error:', error);
      toast.error('Houve um erro ao copiar os métodos');
    }
  };

  return (
    <Layout title="I.LAB">
      <Header>
        <HeaderWrapper onClick={() => goBack()}>
          <IoIosArrowBack color="#FFDF22" size={24} />
          <HeaderLabel>Importar métodos</HeaderLabel>
        </HeaderWrapper>

        <HeaderButtonsContainer>
          <ButtonYellow onClick={handleResetSelectedMethods}>
            Limpar selecionados
          </ButtonYellow>

          <ButtonYellow onClick={handleCopyMethods}>Salvar</ButtonYellow>
        </HeaderButtonsContainer>
      </Header>

      <Container>
        {loading ? (
          <AlertContainer>
            <MoonLoader size={30} color="#FFDF22" />
          </AlertContainer>
        ) : (
          <CardContainer>
            {adminMethods?.map((library) => (
              <Card
                key={library.id}
                data={library}
                selectedMethods={selectedMethodsIds}
                selectMethod={handleSelectMethod}
                removeMethod={handleRemoveMethod}
              />
            ))}
          </CardContainer>
        )}
      </Container>
    </Layout>
  );
}

export default MetLibraryImportMethods;
